import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_importacion_id: new EntityColumn<string>({ name: 'c_importacion_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Importacion Id' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripcion' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK, prompt: 'Fileprocess Id' }),
        c_estado_id: new EntityColumn<string>({ name: 'c_estado_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        cpim_brwStandard: { name: 'cpim_brwStandard', keyMappings: { c_importacion_id: 0 } }
    }
)

const lookups = () =>
(
    {

    }
)

export class ClientesProductosImportacionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('ClientesProductosImportacion');
    }
}